import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useGetCustomService } from 'hooks/rest/useGetCustomService';
import { adaptModels, adaptStrategies } from '../adapters/adaptModelPortfolio';

// --- Interfaces ---

interface UseModelListProps {
    productId?: string | number;
}

/**
 * Replace 'any' with your actual Model and Strategy interfaces
 * if they are defined in your project.
 */
interface UseModelListReturn {
    products: any[];
    strategies: any[];
    isLoading: boolean;
    error: any;
}

// --- Hook ---

export const useModelList = ({ productId }: UseModelListProps): UseModelListReturn => {
    const { i18n } = useTranslation();

    const { data: response, isLoading, error } = useGetCustomService({
        service: 'portfolioManagement',
        api: 'getModelPortfolios',
        payload: [productId, { language: i18n.language }],
        enabled: !!productId,
    });

    const { products, strategies } = useMemo(() => {
        const data = response?.data || [];

        return { products: adaptModels(data), strategies: adaptStrategies(data) };
    }, [response]);

    return {
        products,
        strategies,
        isLoading,
        error,
    };
};
